const postMessageType = "themeChange";
const ATTR_NAME = 'data-theme';
const COOKIES = {
    USER_THEME: 'userTheme',
    // Используется для установки темы системы пользователя в браузерах,
    // что не передают на сервер заголовок о желаемой цветовой теме
    SYSTEM_THEME: 'systemTheme',
};
const sendThemeChangedPostMessage = (windowForPostMessage, theme, domain) => {
    if (typeof windowForPostMessage.postMessage === "undefined")
        return;
    windowForPostMessage.postMessage({ type: postMessageType, value: theme }, domain || "*");
};

export { ATTR_NAME, COOKIES, postMessageType, sendThemeChangedPostMessage };
//# sourceMappingURL=theme.js.map
